<style lang="scss" scoped>
.popup {
    background: #fff;
    .popup-footer {
        margin: 0 -40px -40px -40px;
        width: 100%;
        width: calc(100% + 80px);
        padding: 20px 40px;
        border-top: 1px solid #d1d1d1;
    }
    .offer-container {
        height: 450px;
        overflow-y: auto;
        overflow-x: hidden;
    }
    .select-wrapper {
        position: relative;
        cursor: pointer;
        ::v-deep .activity-card {
            pointer-events: none;
        }
        ::v-deep .activity-card,
        ::v-deep .speaker-card,
        ::v-deep .location-card,
        ::v-deep .gift-card,
        ::v-deep .static-card {
            pointer-events: none;
            display: block !important;
            .title {
                font-size: 1rem !important;
                font-weight: 500 !important;
                line-height: 1.5 !important;
            }
            .media-container {
                margin-bottom: 8px !important;
            }
            .small {
                margin-bottom: 8px !important;
            }
            .subtitle,
            .xsmall,
            button,
            .tag-row {
                display: none;
            }
        }
        .select-placeholder {
            position: absolute;
            opacity: 0;
            pointer-events: none;
            color: #fff;
            transition: opacity 0.15s ease-in-out;
            @media screen and (max-width: 575.98px) {
                display: none;
            }
        }
        .select-overlay {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            pointer-events: none;
            .overlay {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: #0000;
                z-index: 10;
                transition: background 0.15s ease-in-out;
                border-radius: 4px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .select-circle {
                position: absolute;
                width: 24px;
                height: 24px;
                left: 16px;
                top: 16px;
                border-radius: 100%;
                background: #fff;
                transition: background 0.15s ease-in-out;
                @media screen and (max-width: 575.98px) {
                    left: 16px;
                    top: 16px;
                }
                &:after {
                    content: "";
                    display: block;
                    width: 7px;
                    height: 13px;
                    border: solid #fff;
                    border-width: 0 2px 2px 0;
                    transform: rotate(45deg);
                    margin: 3px 0px 0 8px;
                    opacity: 0;
                    transition: opacity 0.15s ease-in-out;
                }
            }
            &.active {
                .select-circle {
                    background: var(--accent);
                    &:after {
                        opacity: 1;
                    }
                }
            }
        }
        &:hover {
            .select-placeholder {
                opacity: 1;
            }
            .select-overlay {
                .overlay {
                    background: #0002;
                }
            }
        }
    }
}
</style>
<template>
    <div class="popup p-24 p-lg-40">
        <h3 class="mb-24" v-html="copyConfig.order_flow.title"></h3>
        <p class="small font-weight-light col-lg-10 px-0 mb-40" v-html="copyConfig.order_flow.description"></p>

        <div class="offer-container">
            <slide-y-down-transition group tag="div" class="row mb-n40">
                <div class="col-6 col-lg-4 mb-40" v-for="activity in items.activity" :key="activity.ID">
                    <div class="select-wrapper" @click.stop="toggleItem('activity', activity.ID)">
                        <activity-card v-show="show" :activity="activity" ratio="284:200" :canHover="false" />
                        <div class="tag-row mt-12">
                            <div class="tag-col">
                                <div class="tag tag-accent-light tag-xs">Activiteit</div>
                            </div>
                        </div>
                        <div class="select-overlay" :style="{ 'padding-top' : `${ (200 / 284) * 100 }%` }" :class="{ active : selected.activity.includes(activity.ID)}">
                            <div class="overlay">
                                <div class="select-circle"></div>
                                <div class="select-placeholder small">Selecteer</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-6 col-lg-4 mb-40" v-for="speaker in items.speaker" :key="speaker.ID">
                    <div class="select-wrapper" @click.stop="toggleItem('speaker', speaker.ID)">
                        <speaker-card v-show="show" :speaker="speaker" ratio="284:200" :canHover="false"></speaker-card>
                        <div class="tag-row mt-12">
                            <div class="tag-col">
                                <div class="tag tag-accent-light tag-xs">Spreker</div>
                            </div>
                        </div>
                        <div class="select-overlay" :style="{ 'padding-top' : `${ (200 / 284) * 100 }%` }" :class="{ active : selected.speaker.includes(speaker.ID)}">
                            <div class="overlay">
                                <div class="select-circle"></div>
                                <div class="select-placeholder small">Selecteer</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-6 col-lg-4 mb-40" v-for="location in items.location" :key="location.ID">
                    <div class="select-wrapper" @click.stop="toggleItem('location', location.ID)">
                        <location-card v-show="show" :location="location" ratio="284:200" :canHover="false"></location-card>
                        <div class="tag-row mt-12">
                            <div class="tag-col">
                                <div class="tag tag-accent-light tag-xs">Locatie</div>
                            </div>
                        </div>
                        <div class="select-overlay" :style="{ 'padding-top' : `${ (200 / 284) * 100 }%` }" :class="{ active : selected.location.includes(location.ID)}">
                            <div class="overlay">
                                <div class="select-circle"></div>
                                <div class="select-placeholder small">Selecteer</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-6 col-lg-4 mb-40" v-for="staticItem in items.staticItem" :key="staticItem.ID">
                    <div class="select-wrapper" @click.stop="toggleItem('staticItem', staticItem.ID)">
                        <static-card v-show="show" class="w-100 h-100" :pages="pages" :staticItem="staticItem" ratio="284:200" :canHover="false"></static-card>
                        <div class="tag-row mt-12">
                            <div class="tag-col">
                                <div class="tag tag-accent-light tag-xs">Extra</div>
                            </div>
                        </div>
                        <div class="select-overlay" :style="{ 'padding-top' : `${ (200 / 284) * 100 }%` }" :class="{ active : selected.staticItem.includes(staticItem.ID)}">
                            <div class="overlay">
                                <div class="select-circle"></div>
                                <div class="select-placeholder small">Selecteer</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-6 col-lg-4 mb-40" v-for="gift in items.gift" :key="gift.ID">
                    <div class="select-wrapper" @click.stop="toggleItem('gift', gift.ID)">
                        <gift-card v-show="show" class="w-100 h-100" :pages="pages" :gift="gift" ratio="284:200" :canHover="false"></gift-card>
                        <div class="tag-row mt-12">
                            <div class="tag-col">
                                <div class="tag tag-accent-light tag-xs">Gift</div>
                            </div>
                        </div>
                        <div class="select-overlay" :style="{ 'padding-top' : `${ (200 / 284) * 100 }%` }" :class="{ active : selected.gift.includes(gift.ID)}">
                            <div class="overlay">
                                <div class="select-circle"></div>
                                <div class="select-placeholder small">Selecteer</div>
                            </div>
                        </div>
                    </div>
                </div>
            </slide-y-down-transition>
        </div>

        <div class="popup-footer d-flex align-items-center">
            <span class="small font-weight-light">{{ total }} activiteit(en) geselecteerd.</span>
            <button class="btn btn-accent ml-auto" :disabled="disabled" @click="submit" v-html="copyConfig.order_flow.cta"></button>
        </div>
    </div>
</template>

<script>
import { SlideYDownTransition } from 'vue2-transitions'

export default {

    components: { SlideYDownTransition },

    props: {
        copyConfig: {
            type: Object,
            required: true,
        },
        pages: {
            type: Array,
            required: false,
            default: null
        },
    },

    data: () => ({
        show: false,
        items: {
            activity: [],
            staticItem: [],
            gift: [],
            speaker: [],
            location: [],
        },
        selected: {
            activity: [],
            staticItem: [],
            gift: [],
            speaker: [],
            location: []
        }
    }),

    mounted() {
        let list = JSON.parse(localStorage.getItem(`ttpe-list`)) || {}

        Object.keys(this.items).forEach(key => {
            if (list.hasOwnProperty(key)) this.items[key] = list[key].filter((item, index, self) =>
                index === self.findIndex((a) => (
                    a.ID === item.ID && a.id === item.id
                ))
            )
        });

        this.show = true
    },

    methods: {
        toggleItem(key, id) {
            if (!this.selected[key].includes(id)) this.selected[key].push(id)
            else this.selected[key].splice(this.selected[key].findIndex(selected_id => selected_id === id), 1)
        },

        submit() {
            window.location.href = route('nl.order', { activities: this.selected.activity, speakers: this.selected.speaker, locations: this.selected.location, staticItems: this.selected.staticItem, gifts: this.selected.gift });
        }
    },

    computed: {
        total() {
            return this.selected.activity.length + this.selected.speaker.length + this.selected.location.length + this.selected.staticItem.length + this.selected.gift.length
        },

        disabled() {
            return this.total <= 0;
        }
    }
}
</script>